// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1387":"c5354a49","9282":"92390087"}[chunkId] + ".chunk.css";
};